import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import { AnimatedSwitch } from 'react-router-transition'

import HomeMain from '../containers/HomeMain'
import NotFound from '../components/shared/NotFound'

const bounceTransition = {
  atEnter: {
    opacity: 0,
    offset: -5,
    foo: 0,
  },
  atLeave: {
    opacity: 0,
    offset: 5,
    foo: 2,
  },
  atActive: {
    opacity: 1,
    offset: 0,
    foo: 1,
  },
};

const AppRouter = () => (
  <BrowserRouter>
    <AnimatedSwitch
      atEnter={bounceTransition.atEnter}
      atLeave={bounceTransition.atLeave}
      atActive={bounceTransition.atActive}
      className="route-wrapper">
      <Route exact path="/" component={HomeMain} />
      <Route exact path="/en" component={HomeMain} />
      <Route component={NotFound} />
    </AnimatedSwitch>
  </BrowserRouter>
);

export default AppRouter;